// @flow

import { startRequest, finishRequest } from "@store/utils";
import { cloneObject } from "@utils/object";
import {
  GetAdviceLibraryCategories,
  GetAdviceLibraryCategoriesSuccess,
  GetAdviceLibraryCategoriesError,
  GetAdviceLibraryTopicSuccess,
  GetAdviceLibraryTopicError,
  ResetAdviceLibraryTopic,
} from "@modules/profile/constants/actions";
import type { AdviceLibraryState } from "./types";

export const initialState: AdviceLibraryState = {
  requestsInProgress: 0,
  error: null,
  currentTopic: null,
  categories: [],
};

const setLoading = (state: AdviceLibraryState) => () => {
  return {
    ...startRequest(state),
  };
};

const onError = (state: AdviceLibraryState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

const onGetAdviceLibraryCategoriesSuccess = (state: AdviceLibraryState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    categories: payload,
  };
};

const onGetAdviceLibraryTopicSuccess = (state: AdviceLibraryState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    currentTopic: payload,
  };
};

const onResetAdviceLibraryTopic = (state: AdviceLibraryState) => ({ payload }: Object) => {
  return {
    ...state,
    currentTopic: null,
  };
};

export default (state: AdviceLibraryState = initialState, action: Object): AdviceLibraryState => {
  const act = {
    [GetAdviceLibraryCategories]: setLoading,
    [GetAdviceLibraryCategoriesSuccess]: onGetAdviceLibraryCategoriesSuccess,
    [GetAdviceLibraryCategoriesError]: onError,
    [GetAdviceLibraryTopicSuccess]: onGetAdviceLibraryTopicSuccess,
    [GetAdviceLibraryTopicError]: onError,
    [ResetAdviceLibraryTopic]: onResetAdviceLibraryTopic,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
